import axios from "axios";
import { IBookingsRceDashboardApiFilter } from "../types";
import { useMutation } from "@tanstack/react-query";
import { IBookingsApiFilter } from "../../../api/types";

type Props = {
    filters?: IBookingsApiFilter
}

export async function getRceDashboardCounter(props: Props) {
    if (!props.filters) {
        return null;
    }

    const resp = await axios.post("/booking/rce-dashoboard/v1/counter", { filters: props.filters });
    return resp.data;
}

export function useRceDashboardCounterMutation() {
    const mutation = useMutation(getRceDashboardCounter);
    return mutation;
}
